import { Component, computed, input, Input, InputSignal, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  ShipmentAppEntityShipmentRead,
  TreeToRemoveAppEntityTreeToRemoveWrite
} from '../../../../../openapi';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import {
  TreesToRemovePreviewComponent
} from '../sections/trees-cutting-info-section/components/trees-to-remove-preview/trees-to-remove-preview.component';
import { toTreeToRemoveFormValues } from '../sections/trees-cutting-info-section/forms/trees-cutting-info-form';
import { PropertyOwnerStatementContentPipe } from '../../../../../pipes/property-owner-statement-content.pipe';

@Component({
  selector: 'app-removal-of-trees-or-shrubs-preview',
  standalone: true,
  imports: [
    AgreementsDataPreviewComponent,
    ApplicantPreviewComponent,
    ApplicationDataPreviewComponent,
    AttachmentsDataPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    TreesToRemovePreviewComponent,
    PropertyOwnerStatementContentPipe
  ],
  templateUrl: './removal-of-trees-or-shrubs-preview.component.html'
})
export class RemovalOfTreesOrShrubsPreviewComponent {
  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public treesToRemove: Signal<TreeToRemoveAppEntityTreeToRemoveWrite[]> = computed(() => {
    const app = this.application();
    if (app) {
      return toTreeToRemoveFormValues(app);
    } else {
      return [];
    }
  });
}
